import http from '../interceptors/Intercepter';

export const createVisit = async (username, visitVOToCreate) => {
  try {
    const { data } = await http.post('/api/visit/create', { username, visitVOToCreate });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateVisit = async (username, visitVOToUpdate) => {
  try {
    const { data } = await http.post('/api/visit/update', { username, visitVOToUpdate });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const retrieveVisitWithPeople = async (username, visitExternalReference) => {
  try {
    const { data } = await http.post('/api/visit/viewWithPeople', { username, visitExternalReference });
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewDropdownVisits = async (username, participantExternalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const queryParams = new URLSearchParams({
      participantExternalReference: participantExternalReference,
      username: username,
    }).toString();

    const { data } = await http.post(`/api/visit/view/dropdown?${queryParams}`, config);

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
